<template>
  <div class="company-content" v-if="hasTeamContent">
    <div class="title">管理团队</div>
    <div class="message">
      深耕行业链接多方资源，驱动产业提质升级
    </div>
    <div class="company-row">
      <div class="company-image">
        <img class="image" :src="companyDesc.cover" alt="logo" />
      </div>
      <div class="company-message" v-html="companyDesc.articleContent"></div>
    </div>
  </div>
</template>

<script>
import { getArticleById, getArticlePage } from '@/api/home/home.js'
export default {
  name: 'Company',
  data() {
    return {
      companyDesc: {} // 公司信息
    }
  },
  computed: {
    hasTeamContent() {
      return !!(
        this.companyDesc?.articleName ||
        this.companyDesc?.articleContent ||
        this.companyDesc?.cover
      )
    }
  },
  created() {
    this.getCurrentArticle()
  },
  methods: {
    getCurrentArticle() {
      getArticlePage({
        page: 1,
        limit: 1,
        categoryCode: 109
      }).then((res) => {
        const currentArticle = res.data?.list?.[0]
        if (!currentArticle) {
          this.companyDesc = {}
          return
        }
        this.companyDesc = currentArticle
        if (currentArticle.articleId) {
          this.getArticleData(currentArticle.articleId)
        }
      })
    },
    // 公司信息
    getArticleData(id) {
      getArticleById(id).then((res) => {
        if (!res.data) return
        this.companyDesc = {
          ...this.companyDesc,
          ...res.data
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.company-content {
  display: flex;
  flex-direction: column;
  width: 1340px;
  margin: 64px auto 150px;
  .company-row {
    display: flex;
    flex-direction: row;
    margin-top: 64px;
    .company-message {
      flex: 1;
      margin-left: 64px;
      font-size: 20px;
      color: #333;
      line-height: 35px;
    }
    .company-image {
      width: 650px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .image {
        width: 650px;
        height: 428px;
        object-fit: contain;
      }
    }
  }
  .message {
    color: #5c5c5c;
    font-size: 18px;
    font-weight: 400;
    height: 28px;
    line-height: 28px;
    text-align: center;
    margin-top: 24px;
  }
  .title {
    color: #111;
    font-size: 40px;
    font-weight: 600;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}

// 手机端css
.mobile-content {
  .company-content {
    width: 345px;
    margin: 32px auto 75px;
    .company-row {
      display: flex;
      flex-direction: column;
      margin-top: 22px;
      .company-message {
        margin-left: 0;
        font-size: 14px;
        line-height: 24px;
      }
      .company-image {
        width: 345px;
        .image {
          width: 345px;
          height: 250px;
        }
      }
    }
    .message {
      font-size: 14px;
      line-height: 20px;
      height: auto;
      margin-top: 12px;
    }
    .title {
      font-size: 24px;
      line-height: 35px;
      height: auto;
    }
  }
}
</style>
